import * as React from 'react';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';

import './css/Site.css';
import './css/Fatture.css';

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

const sessione = new Session();
const config = new Config();
const azioni = new Azioni();
const utils = new Utils();

let _items: IDocument[] = [];

export class StatoRichieste extends React.Component {

    constructor(){
        super();
        this.state = {
            richieste:[],
            errorMessage: '',
            id_cliente: false
        };
        
        this._onChangeFiltraRichieste = this._onChangeFiltraRichieste.bind(this);

    }
                    
    componentDidMount() {
        this._popolaRichieste();
        utils.setBoxInfoCliente();
    }
    
    _popolaRichieste()
    {
        
        let request = new Request( config.get("anagrafica_richieste"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                id_cliente: sessione.get('id_cliente') 
            })
        });
        
        
        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {
            
                _items = [];
                
                // Elenco delle richieste
                if ( result.data.length > 0) {
                    for (let i = 0; i < result.data.length; i++) {
                      _items.push(result.data[i]);
                    }
                }

                this.setState({richieste: _items});
   
            } else {
                this.setState({errorMessage: result.message});
            }
        }.bind(this) )
    }
    
    _onChangeFiltraRichieste(event) {

        this.setState({ richieste: event.target.value ? 
            _items.filter(i =>  ( i.DATA.toLowerCase().indexOf(event.target.value.toLowerCase() ) >-1) || 
                                ( i.TIPO_RICHIESTA.toLowerCase().indexOf(event.target.value.toLowerCase() )>-1) || 
                                ( i.STATO_RICHIESTA.toLowerCase().indexOf(event.target.value.toLowerCase() )  > -1 ) 
                         ) :  _items });
    };

    
    render() {

        return (
        <div id="inner-container">
            <Label className='ms-fontSize-xxl titolo-pagina'>Stato Richieste<span id='boxdettagliocliente'></span></Label>

            <div id='filtri'>
                <div className='boxsearch'>
                <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Filtra per Tipo Richiesta</span></label>
                
                <div id='ricercapod'>
                    <div className="ms-ComboBoxCustomStyledExample">
                        Ricerca <br/>

                        <div className="ms-TextField-wrapper wrapper_df60a678">
                            <div className="ms-TextField-fieldGroup fieldGroup_df60a678">
                                <input type="text" onChange={this._onChangeFiltraRichieste} id="TextField81" className="ms-TextField-field field_df60a678 ms-font-m" />
                            </div>
                        </div>

                    </div>
                </div>


                </div>
             </div>

            <div id="elencorichieste" className="DetailListContainer">
            
            <div id="scarico" >
            <CSVLink data={this.state.richieste} separator={";"} filename={"elenco_richieste.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
            </div>
            
            <DetailsList
                items={this.state.richieste}
                columns={ azioni.restituisciColonneRichieste() }
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                selectionPreservedOnEmptyClick={true}
                onItemInvoked={this._onItemInvoked}
                compact={true}

              />
              </div>


              <div id="boxdialogo"></div>

        </div>
        );
    }
};

export default StatoRichieste;


// WEBPACK FOOTER //
// ./src/AcComponents/StatoRichieste.js